import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";

import { LayoutService } from "./layout.service";
import { StateService } from "./state.service";
import { StorageService } from "./storage.service";

import { CookieService } from "ngx-cookie-service";

import { GeneralService } from "./general.service";
import { LoginService } from "./login.service";
import { OneSignalService } from "./onesignal.service";
import { ProfileService } from "./profile.service";
import { SocialService } from "./social.service";
import { TimelineService } from "./timeline.service";
import { AuthInterceptor } from "./auth.interceptor";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { WSErrorInterceptor } from './ws-error.interceptor';
import { WSInterceptor } from './ws.interceptor';
import { SharedService } from './shared.service';
import {ChatIaService} from "./chat-ia.service";
import { DeviceRegistryService } from "./device-registry.service";

const SERVICES: any[] = [
  LayoutService,
  StateService,
  StorageService,

  GeneralService,
  LoginService,
  OneSignalService,
  ProfileService,
  SocialService,
  TimelineService,
  SharedService,
  ChatIaService,
  DeviceRegistryService,

  { provide: CookieService },
];

@NgModule({
  imports: [CommonModule],
  providers: [
    ...SERVICES,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WSInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WSErrorInterceptor,
      multi: true,
    },
  ],
})
export class DataModule {
  static forRoot(): ModuleWithProviders<DataModule> {
    return <ModuleWithProviders<DataModule>>{
      ngModule: DataModule,
      providers: [
        ...SERVICES,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: WSInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: WSErrorInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true,
        },
      ],
    };
  }
}
